/**
 * LCG seeded random number generator.
 * Produces identical results to SeededRandom.java when given the same seed and call sequence.
 * Algorithm: state = (1664525 * state + 1013904223) mod 2^32  (Numerical Recipes LCG)
 */
export class SeededRandom {
  private state: number;

  constructor(seed: number) {
    this.state = seed >>> 0; // clamp to unsigned 32-bit
  }

  /** Returns a float in [0, 1) */
  next(): number {
    this.state = (Math.imul(1664525, this.state) + 1013904223) >>> 0;
    return this.state / 4294967296;
  }

  /** Returns an integer in [0, max) */
  nextInt(max: number): number {
    return Math.floor(this.next() * max);
  }
}
